module.exports = __webpack_public_path__ + "img/circle.13a1388a.png";